import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const Hero = () => {
  const { t } = useLang();
  return (
    <section className="relative h-[100svh] min-h-[640px] w-full overflow-hidden" data-testid="hero-section">
      <img
        src="https://images.pexels.com/photos/7255159/pexels-photo-7255159.jpeg"
        alt="Lofoten by sea"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B192C]/80 via-[#0B192C]/35 to-[#0B192C]/10" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B192C]/30 to-transparent" />

      <div className="relative z-10 container-x h-full flex flex-col justify-end pb-24 md:pb-28">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="h-display max-w-4xl text-white font-light text-5xl md:text-7xl lg:text-[84px] leading-[1.02] hero-shadow"
          data-testid="hero-title"
        >
          {t.hero.title}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
          className="mt-6 max-w-xl text-white/90 text-lg md:text-xl font-light hero-shadow"
          data-testid="hero-subtitle"
        >
          {t.hero.subtitle}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <Link to="/booking" className="btn-primary bg-white text-[#0B192C] hover:bg-[#F7F5F0]" data-testid="hero-book-now">
            {t.hero.cta_primary} <ArrowRight size={16} />
          </Link>
          <Link to="/activities" className="btn-ghost" data-testid="hero-explore">
            {t.hero.cta_secondary}
          </Link>
        </motion.div>

        <div className="absolute bottom-8 right-6 md:right-10 flex items-center gap-2 text-white/70 text-[11px] tracking-[0.3em] uppercase">
          <ArrowDown size={14} className="animate-bounce" />
          {t.hero.scroll}
        </div>
      </div>
    </section>
  );
};

export default Hero;
